import { render, staticRenderFns } from "./grid-list.vue?vue&type=template&id=c819a2ca"
import script from "./grid-list.vue?vue&type=script&lang=ts"
export * from "./grid-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports